
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  AlertsProvider,
  Alert,
  Category,
  useAlert,
  Button,
  Flex,
  FlexItem,
  FlexJustify,
  Margin,
  Size,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const Demo = ({
  component: Component
}) => {
  const {
    showAlert,
    hideAlert
  } = useAlert();
  return <Flex justify={FlexJustify.START} mdxType="Flex">
      <FlexItem mdxType="FlexItem">
        <Margin size={{
        right: Size.SMALL
      }} mdxType="Margin">
          <Button category={Category.SUCCESS} onClick={() => showAlert({
          category: Category.SUCCESS,
          text: 'Congrats you did it!'
        })} mdxType="Button">
            Show success
          </Button>
        </Margin>
      </FlexItem>
      <FlexItem mdxType="FlexItem">
        <Margin size={{
        right: Size.SMALL
      }} mdxType="Margin">
          <Button category={Category.DANGER} onClick={() => showAlert({
          category: Category.DANGER,
          text: 'Oh oh! Something went bad.'
        })} mdxType="Button">
            Show danger
          </Button>
        </Margin>
      </FlexItem>
      <FlexItem mdxType="FlexItem">
        <Margin size={{
        right: Size.SMALL
      }} mdxType="Margin">
          <Button category={Category.WARNING} onClick={() => showAlert({
          category: Category.WARNING,
          text: 'Oh oh! Careful there.'
        })} mdxType="Button">
            Show warning
          </Button>
        </Margin>
      </FlexItem>
      <FlexItem mdxType="FlexItem">
        <Button category={Category.INFO} onClick={() => showAlert({
        category: Category.INFO,
        text: 'Here is some info. You are welcome.'
      })} mdxType="Button">
          Show info
        </Button>
      </FlexItem>
    </Flex>;
};

const layoutProps = {
  Demo
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Alerts Provider`}</h1>
<p>{`Used to display temporary information regarding an action, or a status due to a user action. The `}<inlineCode parentName="p">{`AlertsProvider`}</inlineCode>{` should be called at the root of the project to provide the container for the alerts to display. The `}<inlineCode parentName="p">{`useAlert`}</inlineCode>{` function hook can then be imported wherever the alert needs to be shown/hidden. See below for an example usage:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// App.js
import { AlertsProvider } from '@drawbotics/react-drylus';

// ...
  return (
    <AlertsProvider>
      <ComponentWithAlerts />
    </AlertsProvider>
  );
// ...

// ComponentWithAlerts.js
import { useAlert } from '@drawbotics/react-drylus';

const ComponentWithAlerts = () => {
  const { showAlert } = useAlert();

  return (
    <button onClick={() => showAlert({ text: 'I am an alert' })}>Show alert when clicked!</button>
  );
};
`}</code></pre>
<p>{`Alerts automatically disappear (except for `}<inlineCode parentName="p">{`danger`}</inlineCode>{` alerts, which need to be manually discarded), though this can be overriden (see `}<inlineCode parentName="p">{`Alert`}</inlineCode>{` docs below). A "discard" button is rendered on all alerts which when clicked, discards them. If you need to discard alerts manually for some other reason you can use `}<inlineCode parentName="p">{`hide`}</inlineCode>{` from the hook to trigger it; though in this case you should provide your own ID for the alert:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// ComponentWithAlerts.js
import { useAlert } from '@drawbotics/react-drylus';

const ComponentWithAlerts = () => {
  const { showAlert, hideAlert } = useAlert();

  return (
    <div>
      <button onClick={() => showAlert({ text: 'I am an alert', id: 'my-alert' })}>Show alert when clicked!</button>
      <button onClick={() => hideAlert('my-alert')}>Hide alert!</button>
    </div>
  );
};
`}</code></pre>
<h3>{`Alert`}</h3>
<p>{`The `}<inlineCode parentName="p">{`show`}</inlineCode>{` function takes exactly the same arguments as the props of `}<inlineCode parentName="p">{`Alert`}</inlineCode>{`, while `}<inlineCode parentName="p">{`hide`}</inlineCode>{` only takes the `}<inlineCode parentName="p">{`id`}</inlineCode>{` (if provided to `}<inlineCode parentName="p">{`show`}</inlineCode>{`).`}</p>
<Playground __position={0} __code={`<Alert category={Category.DANGER} text="This is an information message" onClickDismiss={x=>x} />`} component={Alert} mdxType="Playground">
  <Alert category={Category.DANGER} text="This is an information message" onClickDismiss={x => x} mdxType="Alert" />
</Playground>
<h2>{`Demo`}</h2>
<p>{`Click on the buttons to trigger different alert types.`}</p>

<AlertsProvider mdxType="AlertsProvider">
  <Demo mdxType="Demo" />
</AlertsProvider>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;